import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  Card,
  CardContent,
  useTheme,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"; // Ícone de exemplo
import StarBorderIcon from "@mui/icons-material/StarBorder";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

const features = [
  {
    icon: <CheckCircleOutlineIcon color="primary" sx={{ fontSize: 40 }} />,
    title: "Recurso Incrível 1",
    description:
      "Descrição concisa do benefício ou funcionalidade principal deste recurso.",
  },
  {
    icon: <StarBorderIcon color="primary" sx={{ fontSize: 40 }} />,
    title: "Recurso Chave 2",
    description:
      "Explique como este recurso resolve um problema específico do cliente.",
  },
  {
    icon: <FavoriteBorderIcon color="primary" sx={{ fontSize: 40 }} />,
    title: "Benefício Essencial 3",
    description:
      "Destaque o valor agregado e o diferencial competitivo oferecido.",
  },
];

export const FeaturesSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.paper,
        py: { xs: 8, md: 12 },
      }}
    >
      <Container maxWidth="lg">
        <Typography
          variant="overline"
          align="center"
          display="block"
          gutterBottom
        >
          Recursos
        </Typography>
        <Typography
          variant="h3"
          component="h2"
          align="center"
          gutterBottom
          sx={{ mb: 6, fontWeight: 600, color: theme.palette.text.primary }}
        >
          Por que nos escolher?
        </Typography>
        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card
                elevation={0}
                sx={{
                  textAlign: "center",
                  p: 2,
                  backgroundColor: "transparent",
                }}
              >
                <Box sx={{ mb: 2 }}>{feature.icon}</Box>
                <CardContent sx={{ p: 0 }}>
                  <Typography
                    variant="h6"
                    component="h3"
                    gutterBottom
                    sx={{ fontWeight: 600 }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography variant="body1" color="text.secondary">
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};
